import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fill-height overflow-x-hidden" }
const _hoisted_2 = {
  key: 1,
  class: "hs-form-frame",
  "data-region": "na1",
  "data-form-id": "999801d4-f7fd-4a24-80c2-c8dfcb7e9b87",
  "data-portal-id": "5099377"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { style: {"height":"calc(100% - 48px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "fill-height pa-4",
              justify: "center",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      border: "primary md",
                      flat: "",
                      "min-height": "330"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.loading)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              justify: "center",
                              align: "center",
                              style: {"height":"330px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "auto" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_progress_circular, {
                                      color: "primary",
                                      indeterminate: _ctx.loading
                                    }, null, 8, ["indeterminate"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_2))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}